module.exports = __webpack_public_path__ + "media/img/linkedin-icon-4be7dc9570f212b4b6ca4d4405a86601.png";